import { Button } from "@/components/ui/button"
import * as Card from "@/components/ui/card"
import { Text } from "@/components/ui/text"
import { Show } from "solid-js"
import { Box, Flex } from "styled-system/jsx"

interface QuizIntroProps {
  content?: string
  hasPreviousAttempt: boolean
  previousScore: number
  passingThreshold: number
  onStart: () => void
  onReview: () => void
}

export default function (props: QuizIntroProps) {
  return (
    <Card.Root p={8} textAlign="center">
      <Show
        when={props.hasPreviousAttempt}
        fallback={
          // Standard Intro for first-timers
          <>
            <Text textStyle="xl" fontWeight="semibold" mb={4}>
              Ready to test your knowledge?
            </Text>
            <Show when={props.content}>
              <Box mb={6} color="fg.muted" innerHTML={props.content || ''} />
            </Show>
            <Button size="lg" colorPalette="jade" onClick={props.onStart}>
              Start Quiz
            </Button>
          </>
        }
      >
        <Text textStyle="xl" fontWeight="semibold" mb={4}>
          You have already completed this quiz!
        </Text>
        <Text mb={6}>
          Your previous score was <Text as="span" fontWeight="bold" color={props.previousScore >= props.passingThreshold ? "jade.600" : "red.600"}>{Math.round(props.previousScore * 100)}%</Text>.
          What would you like to do?
        </Text>
        <Flex justify="center" gap={4}>
          <Button variant="outline" size="lg" onClick={props.onReview}>
            Review Answers
          </Button>
          <Button colorPalette="jade" size="lg" onClick={props.onStart}>
            Retake Quiz
          </Button>
        </Flex>
      </Show>
    </Card.Root>
  )
}
